import { createTheme, PaletteMode, Theme } from '@mui/material';

import { colors } from './colors';
import { getPalette } from './palette';
import { fonts, typography } from './typography';

export const createCustomTheme = (mode: PaletteMode): Theme => {
  const palette = getPalette(mode);
  const autofillBg = mode === 'dark' ? colors.primary_30 : colors.white;
  const autofillText = mode === 'dark' ? colors.primary_90 : colors.primary_20;

  return createTheme({
    palette,
    colors,
    spacing: [0, 4, 8, 16, 32, 40, 48],
    typography: {
      ...typography,
      fontFamily: fonts.default,
    },
    components: {
      MuiPopover: {
        styleOverrides: {
          paper: {
            borderRadius: '16px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            marginLeft: 4,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
          },
          input: {
            '&:-webkit-autofill': {
              WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset`,
              WebkitTextFillColor: autofillText,
              transition: 'background-color 9999s ease-in-out 0s',
            },
            '&:-webkit-autofill:hover': {
              WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset`,
              WebkitTextFillColor: autofillText,
            },
            '&:-webkit-autofill:focus': {
              WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset`,
              WebkitTextFillColor: autofillText,
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            borderRadius: '10em',
          },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 560,
        md: 992,
        lg: 1280,
        xl: 1440,
        xxl: 1920,
      },
    },
  });
};

export default createCustomTheme;
